import React, { useEffect, useMemo, useRef } from 'react';
import * as styles from './styles';

const playerList = new Set<any>();

function pauseOthers(player: any) {
  if (!player) {
    return;
  }

  playerList.forEach(p => {
    if (p !== player) {
      p.pauseVideo();
    }
  });
}

function onPlayerStateChange(event: any) {
  if (
    //	@ts-ignore
    event.data === window.YT.PlayerState.PLAYING ||
    //	@ts-ignore
    (event.data === window.YT.PlayerState.BUFFERING &&
      //	@ts-ignore
      event.target.LastPlayerState === window.YT.PlayerState.UNSTARTED)
  ) {
    pauseOthers(event.target);
  }

  if (event.data !== event.target.LastPlayerState) {
    event.target.LastPlayerState = event.data;
  }
}

export function useIframe(
  videoId: string,
  played: boolean,
  apiFulfilled: boolean
) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const iframeEl = useMemo(() => {
    if (!played || !apiFulfilled) {
      return null;
    }

    const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&autohide=1&controls=1&loop=0&rel=0&fs=1&wmode=opaque&showinfo=0&modestbranding=0&iv_load_policy=1&start=0&theme=dark&color=red&html5=1&vq=hd720&enablejsapi=1&origin=${window.origin}`;

    return (
      <div className={styles.iframeContainer}>
        <iframe
          title={videoId}
          ref={iframeRef}
          src={src}
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          allow="autoplay"
        />
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [played, apiFulfilled]);

  useEffect(() => {
    if (!(iframeRef.current && played && apiFulfilled)) {
      return undefined;
    }

    //	@ts-ignore
    const player = new window.YT.Player(iframeRef.current, {
      events: {
        onStateChange: onPlayerStateChange
      }
    });

    playerList.add(player);

    return () => {
      playerList.delete(player);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeRef.current, played, apiFulfilled]);

  return iframeEl;
}
